import { shallow } from 'enzyme'
import React from 'react'

import EventFilter from '../EventFilter'

describe('EventFilter component', () => {
  it('should render without throwing an error', () => {
    const component = shallow(<EventFilter />)
    expect(component).toMatchSnapshot()
    expect(() => component).not.toThrow()
  })
})
